import React from 'react';
import MaskedInput from 'react-maskedinput';
import {FormattedMessage} from 'react-intl';

import {stripProps} from 'shared/stripCorrectProps';

export default class FormDateField extends React.Component {
    static propTypes = {
        field: React.PropTypes.object.isRequired,
        message: React.PropTypes.object.isRequired,
        required: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this._onChange = this._onChange.bind(this);
    }

    _onChange(e) {
        this.props.field.onChange(e.target.value);
    }

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    render() {
        const {required, field, message} = this.props;

        const notRequiredLabelClass = 'login--form__label form__label';
        const requiredLabelClass = 'login--form__label form__label form__label__required';

        const inputClass = 'login--form__control form__control';

        const labelClass = required ? requiredLabelClass : notRequiredLabelClass;

        return (
            <div className="form__row">
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>

                <MaskedInput mask="11.11.1111"
                             placeholder="dd.mm.yyyy"
                             onChange={this._onChange}
                             className={inputClass}
                    {...stripProps(field)}/>
                {field.touched && field.error && FormDateField.renderHint(field.error)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormDateField.jsx